import { ArrowUpDown } from "lucide-react"
import RadixButton from "../../ui/RadixButton"

/**
 * Columns definition for Agents table
 */
export const agentColumns = [
  {
    accessorKey: "id",
    header: ({ column }) => {
      return (
        <RadixButton
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-8 px-2 lg:px-3"
        >
          Agent ID
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </RadixButton>
      )
    },
    cell: ({ row }) => (
      <div className="font-medium">{row.getValue("id")}</div>
    ),
  },
  {
    accessorKey: "name",
    header: ({ column }) => {
      return (
        <RadixButton
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          className="h-8 px-2 lg:px-3"
        >
          Name
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </RadixButton>
      )
    },
    cell: ({ row }) => (
      <div className="font-medium">{row.getValue("name") || "N/A"}</div>
    ),
  },
  {
    accessorKey: "email",
    header: "Email",
    cell: ({ row }) => {
      const email = row.getValue("email")
      if (email) {
        return <span className="text-blue-600 text-sm">{email}</span>
      }
      return <span className="text-gray-400 text-sm">N/A</span>
    },
  },
  {
    accessorKey: "phone",
    header: "Phone",
    cell: ({ row }) => {
      const phone = row.getValue("phone")
      const countryCode = row.original.countryCode
      
      if (!phone) {
        return <span className="text-gray-400 text-sm">-</span>
      }
      
      const formattedPhone = countryCode ? `+${countryCode}${phone}` : phone
      return <div className="text-sm text-gray-700">{formattedPhone}</div>
    },
  },
]
